// MODULES
import { useNavigate } from "react-router-dom";
// import { useState } from "react";
// COMPONENTS
import Navbar from "../../components/app/Navbar";
import { DirectionsBike } from "@material-ui/icons";
// IMAGES
import back from "../../assets/back.png";
import download from "../../assets/download.png";
import flag from "../../assets/flag.png";
import road from "../../assets/road.png";
import time from "../../assets/time.png";
import copy from "../../assets/copy.png";
import map from "../../assets/map.png";

export default function DeliveryDetails() {
  const navigate = useNavigate();
  return (
    <div>
      <div>
        <Navbar />
      </div>
      <div className="lg:grid grid-cols-4 gap-5 px-6 lg:px-16 py-6 lg:py-14 max-lg:space-y-7">
        <div>
          <div onClick={() => navigate(-1)}>
            <div className="flex items-center py-5 space-x-2 cursor-pointer">
              <img src={back} alt="" className="w-5" />
              <h1 className="font-medium text-lg">Back</h1>
            </div>
          </div>
        </div>
        <div className="col-span-3 border border-border rounded-[10px] p-5">
          <div className="flex items-center justify-between mb-7">
            <h1 className="font-semibold text-2xl">History</h1>
            <div className="flex items-center space-x-2 bg-border/20 px-5 py-1 rounded-[10px] cursor-pointer">
              <img src={download} className="w-6 h-6" alt="" />
              <h1 className="font-medium text-sm text-themeText">
                Download receipt
              </h1>
            </div>
          </div>
          <div className="border border-border rounded-[10px] p-5 lg:flex pb-72">
            <div className="lg:w-[60%]">
              <div className="flex items-center justify-between mb-6">
                <h1 className="text-lg font-semibold">Delivery details</h1>
                <div className="flex items-center space-x-1">
                  <img src={flag} alt="" className="w-6 h-6" />
                  <h1 className="text-lg text-error font-medium cursor-pointer">
                    Report
                  </h1>
                </div>
              </div>
              <div>
                <div className="flex items-center justify-between mb-7">
                  <div className="flex items-center space-x-2">
                    <div className="text-themeText">
                      <DirectionsBike fontSize="large" />
                    </div>
                    <div>
                      <h1 className="text-themeGray text-sm font-medium">
                        Amount
                      </h1>
                      <h1 className="font-semibold text-2xl text-themeText">
                        NGN 1,200.00
                      </h1>
                    </div>
                  </div>

                  <div className="bg-success/10 py-2 px-4 rounded-[10px] cursor-pointer">
                    <h1 className="text-success font-semibold text-lg">
                      Normal
                    </h1>
                  </div>
                </div>
              </div>
              <div>
                <div className="space-x-2 flex items-center">
                  <h1 className="text-themeGray font-medium">
                    Payment method{" "}
                  </h1>
                  <h2 className="font-semibold text-themeText">
                    Visa *****2530
                  </h2>
                </div>
                <div className="flex items-center space-x-2 my-2">
                  <img src={road} alt="" className="w-[18px] h-[16px]" />
                  <h1 className="font-medium">1.2 kilometres</h1>
                </div>
                <div className="flex items-center space-x-2 my-2">
                  <img src={time} alt="" className="w-[15px] h-[15px]" />
                  <h1 className="font-medium">49 mins</h1>
                </div>
                <div className="flex items-center space-x-2 my-2 w-fit px-3 py-1 rounded-[10px] bg-border/20">
                  <h1 className="font-medium">RQW_2131212</h1>
                  <img
                    src={copy}
                    alt=""
                    className="w-[14px] h-[14px] cursor-pointer"
                  />
                </div>
              </div>
              <div className="my-7">
                <h1 className="text-lg font-semibold mb-3">Route</h1>
                <div className="flex space-x-2 ">
                  <div className="text-center my-3">
                    <h1>From</h1>
                    <div className="h-5 bg-themeText w-[2px] mx-auto"></div>
                    <h1>To</h1>
                  </div>
                  <div className="bg-border p-3 bg-opacity-[0.15] rounded-lg w-full">
                    <div className="relative flex items-center justify-between">
                      <h1 className="text-paragraph font-medium my-2">
                        Shomolu Lagos
                      </h1>
                      <div>
                        <h1 className="font-medium text-paragraph">1:56 PM</h1>
                      </div>
                    </div>

                    <div className="relative flex items-center justify-between">
                      <h1 className="my-2 text-paragraph font-medium">
                        Bola Kemi, Lagos Nigeria
                      </h1>
                      <div>
                        <h1 className="font-medium text-paragraph">2:34 PM</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:w-[40%] px-4">
              <img src={map} alt="" className="h-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
